module.exports = __webpack_public_path__ + "static/media/grupo-2.dfb4635d.png";